import { INCREMENT_NOTIFICATION_BADGE, RESET_NOTIFICATION_BADGE } from '../actions/notificationBadge';

// Notifications that arrived since the bell page was last opened
const notificationBadge = (state = { unseen: 0 }, action) => {
  switch (action.type) {
    case INCREMENT_NOTIFICATION_BADGE:
    case 'INCREMENT_UNSEEN_ALERTS': // a new price alert from the socket (useAlertUpdates)
      return { unseen: state.unseen + 1 };
    case RESET_NOTIFICATION_BADGE:
      return { unseen: 0 };
    default:
      return state;
  }
};

export default notificationBadge;
